import axiosPost from "./axiosPost";

export const SFConnectionRolGet = async (credentials, data) => {
    const body = {
        service: "SFConnectionRolGet",
        params: {
            SFHotelId: data?.SFHotelId ?? null,
        },
    };

    const result = await axiosPost(body, credentials);

    if (result?.status?.code === 0) {
        return [result.status];
    }

    return result.result;
};
